import I18n from "i18next";
import * as Scrivito from "scrivito";
import { get } from "lodash-es";
import editingDe from "./locales/editing/de.json";
import editingEn from "./locales/editing/en.json";
import liveDe from "./locales/live/de.json";
import liveEn from "./locales/live/en.json";

const resources = {
  de: { editing: editingDe, live: liveDe },
  en: { editing: editingEn, live: liveEn },
};

I18n.init({
  resources,
  partialBundledLanguages: true,
  fallbackLng: ["de", "en"],
  debug: false,
  ns: ["editing", "live"],
  defaultNS: "live",
  interpolation: {
    escapeValue: false, // not needed for react!!
  },
});

Scrivito.load(
  () =>
    Scrivito.Obj.onAllSites()
      .where("_objClass", "equals", "LocalsConfigObj")
      .take(1)[0]
).then((obj) => {
  const json = JSON.parse(obj.get("locals"));
  const namespaces = ["live", "editing"];
  I18n.languages.forEach((lang) => {
    namespaces.forEach((ns) => {
      I18n.addResourceBundle(lang, ns, get(json, [lang, ns]) || {}, true, true);
    });
  });
});

export default I18n;
